/*
IndexedDB.js
初始化DB,以及获取到DB
 */

import {openDB} from "idb";
import {INDEXED_DB_NAME, INDEXED_DB_VERSION} from "../Common/constants";

// 初始化数据库
export async function initDB() {
    try {
        const db = await openDB(INDEXED_DB_NAME, INDEXED_DB_VERSION, {
            upgrade(db) {
                // sessions会话
                if (!db.objectStoreNames.contains('sessions')) {
                    // 创建对象存储，主键为 sessionId
                    db.createObjectStore('sessions', {keyPath: 'sessionID', autoIncrement: true});
                }
                // 双增公式卡片
                if (!db.objectStoreNames.contains('doubleFML')) {
                    // 创建对象存储，主键为 sessionId
                    db.createObjectStore('doubleFML', {keyPath: 'id', autoIncrement: true});
                }
            },
        });
        return db;
    } catch (e) {
        console.log(e);
    }
}

// 插入或更新会话
export async function saveSession(session) {
    const db = await initDB();
    await db.put('sessions', session);
}

// 获取所有会话
export async function getAllSessions() {
    const db = await initDB();
    return await db.getAll('sessions');
}

// 删除单个会话
export async function deleteSession(sessionId) {
    const db = await initDB();
    await db.delete('sessions', sessionId);
}

// 清空所有会话
export async function clearAllSessions() {
    const db = await initDB();
    await db.clear('sessions');
}

// 获取单个会话
export async function getSessionById(sessionId) {
    const db = await initDB();
    return await db.get('sessions', sessionId);
}

// 更新会话标题
export async function updateSessionTitle(sessionId, title) {
    const db = await initDB();
    const session = await db.get('sessions', sessionId);
    session.title = title;
    await db.put('sessions', session);
}

// 获取会话的标题
export async function getSessionTitle(sessionId) {
    const db = await initDB();
    const session = await db.get('sessions', sessionId);
    return session.title;
}

// 添加新的对话message
export async function addSessionMessages(sessionId, message) {
    const db = await initDB();
    const session = await db.get('sessions', sessionId);
    // 更改message的key
    const length = session.messages.length;
    // message.id = `msg_${length}`;
    message.id = length;
    session.messages.push(message);
    await db.put('sessions', session);
}

// 获取某个session的所有消息
export async function getSessionMessages(sessionId) {
    const db = await initDB();
    const session = await db.get('sessions', sessionId);
    let messages = [];
    if (session.messages.length > 0) {
        messages = session.messages.sort((a, b) => a.id - b.id) //首先按照升序从小到大排序
            .map(({id, ...rest}) => rest); // 创建新列表，去掉 id 属性
    }
    return messages;
}

// 获取会话的建议问题
export async function getSessionSuggestions(sessionId) {
    const db = await initDB();
    const session = await db.get('sessions', sessionId);
    return session.suggestions;
}

// 更新会话的建议问题
export async function updateSessionSuggestions(sessionId, suggestions) {
    const db = await initDB();
    const session = await db.get('sessions', sessionId);
    session.suggestions = suggestions;
    await db.put('sessions', session);
}
